import React from "react";

import { 
  Row,
  Col,  
} from "antd";

 export default function UserAccount(props){
    return <>{props&&props.accounts
        ? props.accounts.map((item) => {
            return (<div>
                <p Key={item.id} className='mi_address_card'>{item.account_Type_Name}</p>
                <Row span={24}>
                  <Col  md={6} sm={24}>
                    <p className="mi_name">Account Name</p>
                    <p className="mi_value">{item.acc_Holder_Name}</p>
                  </Col>
                  <Col  md={6} sm={24}>
                    <p className="mi_name">Account Number</p>
                    <p className="mi_value">{item.acc_Number}</p>
                  </Col>
               
                  <Col  md={6} sm={24}>
                    <p className="mi_name">State Code</p>
                    <p className="mi_value">{item.country_Code}</p>
                  </Col>
                  <Col  md={6} sm={24}>
                    <p className="mi_name">Is Primary Account</p>
                    <p className="mi_value">{item.isprimaryAcc ? "Yes" : "No"}</p>
                  </Col>
                </Row>
              </div>);
        }) : ''}</>;
};